import router from "./router";
import store from "./store";

// window.localStorage.setItem('storageAside', '0')
let isRouter = true;

router.beforeEach((to, from, next) => {
  // if (window.localStorage.getItem('storageAside') === '0') {
  if (isRouter && store.state.router && store.state.router.length != 0) {
    // window.localStorage.setItem('storageAside', '1')
    // store.dispatch('GetRouter').then(routes => {
    //     // console.log(translateViewRoute(routes, '', []))
    //     router.addRoutes(translateViewRoute(routes, '', []))
    //     store.dispatch('getViewRouter', translateViewRoute(routes, '', []));
    // });

    const accessRouter = store.state.router;
    router.addRoutes(translateViewRoute(accessRouter, "", []));
    isRouter = false;
    next({ ...to, replace: true });
  } else {
    next();
  }
});

export const translateViewRoute = (data, path, arr) => {
  data.forEach((item) => {
    let routeItem = {
      name: item.name,
      path: path ? addPath(item.path, path) : item.path,
      meta: item.meta,
      hide: item.hide,
      component: () => import(`@/views${item.component}`),
      redirect: item.redirect && item.redirect,
      children: item.children
        ? translateViewRoute(
            item.children,
            path ? addPath(item.path, path) : item.path,
            []
          )
        : [],
    };
    arr.push(routeItem);
  });

  return arr;
};

const addPath = (path, fatherPath) => {
  return fatherPath + "/" + path;
};
